import React, { useContext as useContextCore } from 'react'
import type { UseListResult } from '@ztechapps/common.hook'
import type { WorkOrder } from '@ztechapps/common.contract'
import { useWorkOrderList } from '@ztechapps/work-order.common'

export type WorkOrderListContextProps = {
  filterCategory?: string
  children: React.ReactNode
}
export type WorkOrderListProps = Omit<WorkOrderListContextProps, 'children'>

export type WorkOrderListContextType = {
  filterCategory: string
  workOrderList: UseListResult<WorkOrder>
} & WorkOrderListProps

const context = React.createContext({} as WorkOrderListContextType)
const CoreProvider = context.Provider
const defaultFilterCategory = 'workOrderFilterCategory'

export const WorkOrderListProvider = ({ children, filterCategory, ...rest }: WorkOrderListContextProps) => {
  filterCategory = filterCategory ?? defaultFilterCategory

  const workOrderList = useWorkOrderList({ listActionOptions: { storageKey: filterCategory } })

  return (
    <CoreProvider
      value={{
        ...rest,
        workOrderList,
        filterCategory,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useWorkOrderListContext = () => useContextCore(context)
